import { useState, useEffect, useRef } from 'react';
import { persistentContentCache } from '@/services/persistentContentCacheService';

export function useRandomSeriesCover(campaignCountriesLanguagesId: string | null) {
  const [coverUrl, setCoverUrl] = useState<string | null>(null);
  const selectedRef = useRef<string | null>(null);

  useEffect(() => {
    if (selectedRef.current) {
      setCoverUrl(selectedRef.current);
      return;
    }

    if (!campaignCountriesLanguagesId) return;

    let cancelled = false;

    (async () => {
      try {
        const series = await persistentContentCache.getSeries(campaignCountriesLanguagesId);
        if (cancelled || !series || series.length === 0) return;

        const withThumbnail = series.filter((s) => s.thumbnail);
        if (withThumbnail.length === 0) return;

        const random = withThumbnail[Math.floor(Math.random() * withThumbnail.length)];
        selectedRef.current = random.thumbnail;
        setCoverUrl(random.thumbnail);
      } catch (_) {}
    })();

    return () => {
      cancelled = true;
    };
  }, [campaignCountriesLanguagesId]);

  return coverUrl;
}
